/* eslint-disable no-undef */
import { WelcomeAnimation } from "../component/Transitions";
import Logo from "../img/logo2-01.svg"
import Github from '../img/github.svg'
import LinkedIn from '../img/linkedin.svg'

export default function Welcome() {
  setTimeout(() => {
    document.getElementById('trigger').checked = false
  }, 1);
  return (
    <main className="welcome-container">
      <WelcomeAnimation>
        <img src={Logo} alt="Logo" className="welcome-logo"/>
        <h1 className="welcome-name">Hi, I'm Luthfi</h1>
        <h3 className="welcome-job">Front-End Developer</h3>
        <div className="welcome-icon">
          <a href="https://github.com/LuthfiDbz" target={"_blank"} rel={"noreferrer"}><img src={Github} alt=""/></a>
          <a href="https://www.linkedin.com/in/luthfinoer/" target={"_blank"} rel={"noreferrer"}><img src={LinkedIn} alt=""/></a>
        </div>
      </WelcomeAnimation>
    </main>
  )
}